import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/creationApply/page', data, {
    trim: true
  })
}

// 删除
export function deleteById (id) {
  return request.get(`/business/creationApply/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/creationApply/delete/batch', {
    params: {
      ids
    }
  })
}
